import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeleteChatState {
    loading: boolean;
    error: string | null;
    success: boolean;
}

const initialState: DeleteChatState = {
    loading: false,
    error: null,
    success: false,
};

const deleteChatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        deleteChatRequest: (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        deleteChatSuccess: (state) => {
            state.loading = false;
            state.success = true;
        },
        deleteChatFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
            state.success = false;
        },
    },
});

export const { deleteChatRequest, deleteChatSuccess, deleteChatFailure } = deleteChatSlice.actions;

export const deleteChatReducer = deleteChatSlice.reducer;
export const chatActionTypes = deleteChatSlice.actions;
